import { GETEmployeeSkillsResponse } from '@cbgms/api/modules/employee-skills'

export const getOptions = (response: GETEmployeeSkillsResponse) => {
  return response.Data.map(item => ({
    key: item.EmployeeSkill.UUID,
    value: item.EmployeeSkill.UUID,
    text: item.EmployeeSkill.Title
  }))
}
